import DescriptionIcon from "@mui/icons-material/DescriptionOutlined";

const CommentaryPDFButton = ({ assignment, showCommentaryPDF }) => {
  return (
    <button
      onClick={() => showCommentaryPDF(assignment)}
      style={{
        backgroundColor: "#F6F8FA",
        border: "1px solid #EBEBEB",
        borderRadius: "5px",
        padding: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      title="문서 열기"
    >
      <DescriptionIcon
        style={{
          fill: "#000000",
          fontSize: "24px",
          stroke: "#EBEBEB",
        }}
      />
    </button>
  );
};

export default CommentaryPDFButton;
